module.exports = __webpack_public_path__ + "img/log.d9c2283c.png";